/**
 * B1084 — the buyer tools registered with the browser while the page shows
 * them, taken back when it stops. undefined registers nothing (the embedded
 * widget: its host page owns its own agent surface).
 */
import { useEffect } from "react";
import { modelContextOf, registerBuyerTools, type WebMcpTool } from "./webMcp.js";

export function useWebMcp(tools: readonly WebMcpTool[] | undefined): void {
  useEffect(() => {
    if (tools === undefined || typeof navigator === "undefined") return undefined;
    return registerBuyerTools(modelContextOf(navigator), tools);
  }, [tools]);
}
